import React, { useEffect, useState } from 'react';
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Typography, IconButton, TextField, Alert, AlertTitle } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import { Form, Formik } from 'formik';
// import { InputField, TextAreaField } from '../../../../components/formFields';
import { initialValues } from '../formik/formModels/formInitialValues';
import { validationSchema } from '../formik/formModels/validationSchema';
import { linksEncuestasFormModel } from '../formik/formModels/linksEncuestasFormModel';
import { useDispatch, useSelector } from 'react-redux';
import { startCreateLinkEncuesta, startUpdateLinkEncuesta } from '../../../../store/links_encuestas';
import { getWhatsappTemplatesStore } from '../../../../store/ratings';
// import { useResponseHandler } from '../commons/hooks/useResponseHandler';
import { mapLinkEncuestaFormToApi } from '../mappers/linksEncuestasMapper';
import { useResponseHandler } from '../../../../hooks/useResponseHandler';
import InputField from '../../../../components/formFields/InputField';
import TextAreaField from '../../../../components/formFields/TextAreaField';
import AutocompleteField from '../../../../components/formFields/autocompleteField';
import { formatDateToYmdNumeric } from '../../../../commons/utils';

const { formId, formField } = linksEncuestasFormModel;

export const FormLinksEncuestasModal = ({ 
    open, 
    onClose, 
    isEdit = false, 
    editData = null,
    isViewMode = false
}: any) => {
    
    const dispatch = useDispatch();
    const { handleResponse, ResponseComponents } = useResponseHandler();
    const { user } = useSelector((state: any) => state.auth); // Assuming user info is here
    const { links_surveys_for_select, links_users_for_select, links_share_templates_for_select } = useSelector((state: any) => state.linksEncuestas);
    const { whatsapp_templates_list } = useSelector((state: any) => state.ratingsDevices);

    useEffect(() => {
        dispatch(getWhatsappTemplatesStore());
    }, [dispatch]);


    const [currentInitialValues, setCurrentInitialValues] = useState<any>(initialValues);

    useEffect(() => {
        if ((isEdit || isViewMode) && editData) {
            setCurrentInitialValues({
                [formField.name.name]: editData.name || '',
                [formField.description.name]: editData.description || '',
                [formField.surveyId.name]: editData.survey ? { value: editData.survey.id, label: editData.survey.name } : null,
                [formField.userId.name]: editData.user ? { value: editData.user.id, label: editData.user.name } : null,
                [formField.fechaEvento.name]: editData.eventDate || '',
                [formField.nombreEvento.name]: editData.eventName || '',
                [formField.nombreCliente.name]: editData.clientName || '',
                [formField.telefonoCliente.name]: editData.clientPhone || '',
                [formField.emailCliente.name]: editData.clientEmail || '',
                [formField.diaNacimiento.name]: editData.birthDay ? editData.birthDay.toString().padStart(2, '0') : '',
                [formField.mesNacimiento.name]: editData.birthMonth ? editData.birthMonth.toString().padStart(2, '0') : '',
                [formField.shareTemplate.name]: editData.shareTemplate ? { value: editData.shareTemplate.id || editData.shareTemplate.value, label: editData.shareTemplate.title || editData.shareTemplate.name || editData.shareTemplate.label } : null
            });
        } else {
            setCurrentInitialValues(initialValues);
        }
    }, [isEdit, isViewMode, editData]);

    const handleSubmit = async (values: any, actions: any) => {
        
        const payload = mapLinkEncuestaFormToApi(values, user);
        
        let response: any;
        if (isEdit && editData?.id) {
            response = await dispatch(startUpdateLinkEncuesta(editData.id, payload));
        } else {
            response = await dispatch(startCreateLinkEncuesta(payload));
        }


        await handleResponse(response, isEdit ? 'editar link' : 'crear link', true);
        
        actions.setSubmitting(false);
        

        if (response?.ok) {
            onClose();
        }
    }

    return (
        <>
            {ResponseComponents}
            <Dialog 
                open={open} 
                onClose={onClose} 
                maxWidth="sm" 
                fullWidth
                PaperProps={{
                    sx: {
                        borderRadius: 3,
                        boxShadow: '0px 12px 24px -4px rgba(145, 158, 171, 0.12), 0px 0px 2px 0px rgba(145, 158, 171, 0.2)',
                    }
                }}
            >
                <DialogTitle sx={{ m: 0, p: 3, display: 'flex', alignItems: 'center' }}>
                    <Box sx={{
                        width: 48,
                        height: 48,
                        borderRadius: '50%',
                        backgroundColor: 'rgba(105, 108, 255, 0.08)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mr: 2,
                        color: '#696cff'
                    }}>
                        {isViewMode ? <VisibilityOutlinedIcon sx={{ fontSize: 24 }} /> : isEdit ? <EditOutlinedIcon sx={{ fontSize: 24 }} /> : <SaveOutlinedIcon sx={{ fontSize: 24 }} />}
                    </Box>
                    <Box>
                        <Typography variant="h6" sx={{ fontWeight: 700, color: '#32475CDE', lineHeight: 1.2 }}>
                            {isViewMode ? 'Detalles del Link de Encuesta' : isEdit ? 'Editar Link de Encuesta' : 'Crear Link de Encuesta'}
                        </Typography>
                        <Typography variant="body2" sx={{ color: '#32475C99', mt: 0.5 }}>
                            {isViewMode ? 'Información del link de encuesta' : isEdit ? 'Actualiza la información del link' : 'Agrega un nuevo link de encuesta'}
                        </Typography>
                    </Box>
                    
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 16,
                            top: 16,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                </DialogTitle>
            
            <Formik
                initialValues={currentInitialValues}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
                enableReinitialize
            >
                {({ isSubmitting, isValid, dirty }) => (
                    <Form id={formId}>
                        <DialogContent dividers sx={{ p: 3, borderTop: '1px solid #32475C1F', borderBottom: '1px solid #32475C1F' }}>
                            <Grid container spacing={3}>
                                <Grid size={{ xs: 12 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', mb: -1 }}>
                                        Datos del Link / Enlace
                                    </Typography>
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <InputField
                                        name={formField.name.name}
                                        label={formField.name.label}
                                        fullWidth
                                        autoComplete='off'
                                        InputProps={{ readOnly: isViewMode }}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    {isViewMode ? (
                                        <TextField
                                            label={formField.shareTemplate.label}
                                            value={currentInitialValues[formField.shareTemplate.name]?.label || 'Ninguno'}
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                            variant="outlined"
                                        />
                                    ) : (
                                        <AutocompleteField
                                            name={formField.shareTemplate.name}
                                            label={formField.shareTemplate.label}
                                            options={links_share_templates_for_select}
                                            fullWidth
                                        />
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12 }}>
                                    {isViewMode ? (
                                        <TextField
                                            label={formField.surveyId.label}
                                            value={editData?.survey?.label || editData?.survey?.name || 'Sin datos'}
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                            variant="outlined"
                                        />
                                    ) : (
                                        <AutocompleteField
                                            name={formField.surveyId.name}
                                            label={formField.surveyId.label}
                                            options={links_surveys_for_select}
                                            fullWidth
                                        />
                                    )}
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    {isViewMode ? (
                                        <TextField
                                            label={formField.userId.label}
                                            value={editData?.user?.label || editData?.user?.name || 'Sin datos'}
                                            fullWidth
                                            InputProps={{ readOnly: true }}
                                            variant="outlined"
                                        />
                                    ) : (
                                        <AutocompleteField
                                            name={formField.userId.name}
                                            label={formField.userId.label}
                                            options={links_users_for_select}
                                            fullWidth
                                        />
                                    )}
                                </Grid>
                                
                                <Grid size={{ xs: 12 }}>
                                    <Typography variant="subtitle2" sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', mt: 1, mb: -1 }}>
                                        Datos del Cliente y Evento
                                    </Typography>
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <InputField
                                        name={formField.fechaEvento.name}
                                        label={formField.fechaEvento.label}
                                        type="date"
                                        fullWidth
                                        InputLabelProps={{ shrink: true }}
                                        InputProps={{ readOnly: isViewMode }}
                                    />
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <InputField
                                        name={formField.nombreEvento.name}
                                        label={formField.nombreEvento.label}
                                        fullWidth
                                        autoComplete='off'
                                        InputProps={{ readOnly: isViewMode }}
                                    />
                                </Grid>

                                <Grid size={{ xs: 12 }}>
                                    <InputField
                                        name={formField.nombreCliente.name}
                                        label={formField.nombreCliente.label}
                                        fullWidth
                                        autoComplete='off'
                                        InputProps={{ readOnly: isViewMode }}
                                    />
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <InputField
                                        name={formField.telefonoCliente.name}
                                        label={formField.telefonoCliente.label}
                                        type="number"
                                        fullWidth
                                        autoComplete='off'
                                        InputProps={{ readOnly: isViewMode }}
                                    />
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <InputField
                                        name={formField.emailCliente.name}
                                        label={formField.emailCliente.label}
                                        type="email"
                                        fullWidth
                                        autoComplete='off'
                                        InputProps={{ readOnly: isViewMode }}
                                    />
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <InputField
                                        name={formField.diaNacimiento.name}
                                        label={formField.diaNacimiento.label}
                                        type="number"
                                        fullWidth
                                        autoComplete='off'
                                        InputProps={{ readOnly: isViewMode, inputProps: { min: 1, max: 31 } }}
                                    />
                                </Grid>

                                <Grid size={{ xs: 12, sm: 6 }}>
                                    <InputField
                                        name={formField.mesNacimiento.name}
                                        label={formField.mesNacimiento.label}
                                        type="number"
                                        fullWidth
                                        autoComplete='off'
                                        InputProps={{ readOnly: isViewMode, inputProps: { min: 1, max: 12 } }}
                                    />
                                </Grid>
                                <Grid size={{ xs: 12 }}>
                                    <TextAreaField
                                        name={formField.description.name}
                                        label={formField.description.label}
                                        fullWidth
                                        multiline
                                        rows={4}
                                        InputProps={{ readOnly: isViewMode }}
                                    />
                                </Grid>

                                { (isEdit || isViewMode) && editData && (
                                    <Grid size={{ xs: 12 }}>
                                        <Box sx={{ 
                                            display: 'flex', 
                                            flexDirection: 'column', 
                                            gap: 1.5,
                                            backgroundColor: 'rgba(50, 71, 92, 0.04)',
                                            p: 2,
                                            borderRadius: 2,
                                            border: '1px solid rgba(50, 71, 92, 0.1)'
                                        }}>
                                            <Box>
                                                <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Url / Link
                                                </Typography>
                                                <Typography variant="body2" sx={{ wordBreak: 'break-all', mt: 0.5, color: 'text.primary' }}>
                                                    {editData?.token || 'N/A'}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Fecha de Creación
                                                </Typography>
                                                <Typography variant="body2" sx={{ mt: 0.5, color: 'text.primary' }}>
                                                    {editData?.createdAt ? formatDateToYmdNumeric(editData.createdAt) : 'N/A'}
                                                </Typography>
                                            </Box>
                                            <Box>
                                                <Typography variant="caption" sx={{ fontWeight: 600, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
                                                    Respuesta
                                                </Typography>
                                                <Typography variant="body2" sx={{ mt: 0.5, color: editData?.responseAt ? 'text.primary' : 'error.main' }}>
                                                    {editData?.responseAt ? formatDateToYmdNumeric(editData.responseAt) : 'Sin contestar'}
                                                </Typography>
                                            </Box>
                                        </Box>
                                    </Grid>
                                )}

                                <Grid size={{ xs: 12 }}>
                                    <Box sx={{ 
                                        display: 'flex', 
                                        alignItems: 'flex-start', 
                                        backgroundColor: 'rgba(105, 108, 255, 0.08)', 
                                        p: 2, 
                                        borderRadius: 2,
                                        mt: 1
                                    }}>
                                        <InfoOutlinedIcon sx={{ color: '#696cff', mr: 1, fontSize: 20 }} />
                                        <Typography variant="body2" sx={{ color: '#696cff' }}>
                                            {isViewMode ? 'Estás en modo de solo lectura. No puedes modificar esta información.' : isEdit 
                                                ? 'Puedes modificar el nombre y la descripción del link.'
                                                : 'Este link podrá ser distribuido para recibir retroalimentación.'}
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                        </DialogContent>
                        
                        <DialogActions sx={{ p: 3, justifyContent: 'flex-end', gap: 2 }}>
                            <Button 
                                onClick={onClose} 
                                disabled={isSubmitting}
                                variant="outlined"
                                sx={{ 
                                    borderRadius: 2,
                                    px: 3,
                                    fontWeight: 600,
                                    textTransform: 'none'
                                }}
                            >
                                {isViewMode ? 'Cerrar' : 'Cancelar'}
                            </Button>
                            { !isViewMode && (
                                <Button 
                                    type="submit" 
                                    disabled={isSubmitting || (!isValid && !dirty)} 
                                    variant="contained" 
                                    color="primary"
                                    sx={{ 
                                        borderRadius: 2,
                                        px: 3,
                                        fontWeight: 600,
                                        textTransform: 'none',
                                        boxShadow: '0px 4px 8px -4px rgba(105, 108, 255, 0.42)'
                                    }}
                                >
                                    {isEdit ? 'Guardar Cambios' : 'Crear Link'}
                                </Button>
                            )}
                        </DialogActions>
                    </Form>
                )}
            </Formik>
            </Dialog>
        </>
    );
}
